import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube } from "lucide-react";
import WhatsAppLogo from "@/components/site/WhatsAppLogo";
import Logo from "@/components/site/Logo";
import { useI18n } from "@/i18n/I18nProvider";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-20">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <Logo size={56} />
            <div>
              <div className="font-display font-semibold text-slate-900 text-lg leading-tight">Ramdev Steel</div>
              <div className="label-eyebrow text-slate-500">Furniture & Fabrication</div>
            </div>
          </div>
          <p className="text-slate-600 max-w-md leading-relaxed">
            {t.footer.tagline}. Crafted with the belief that steel deserves care.
          </p>
          <div className="flex items-center gap-2 mt-6">
            <a href="#" aria-label="Instagram" className="w-10 h-10 grid place-items-center rounded-full border border-slate-200 bg-white text-slate-600 hover:text-slate-900 hover:border-slate-400 transition-colors"><Instagram size={16} /></a>
            <a href="#" aria-label="Facebook" className="w-10 h-10 grid place-items-center rounded-full border border-slate-200 bg-white text-slate-600 hover:text-slate-900 hover:border-slate-400 transition-colors"><Facebook size={16} /></a>
            <a href="#" aria-label="YouTube" className="w-10 h-10 grid place-items-center rounded-full border border-slate-200 bg-white text-slate-600 hover:text-slate-900 hover:border-slate-400 transition-colors"><Youtube size={16} /></a>
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="label-eyebrow mb-4">Contact</div>
          <ul className="space-y-3 text-slate-700 text-sm">
            <li className="flex items-start gap-2.5"><MapPin size={14} className="mt-1 text-[var(--steel)] shrink-0" /><span>Ramdev Steel, Lingsugur,<br />Karnataka – 584122</span></li>
            <li className="flex items-center gap-2.5"><Phone size={14} className="text-[var(--steel)]" /><a href="tel:+919731852956" className="hover:text-slate-900">+91 97318 52956</a></li>
            <li className="flex items-center gap-2.5"><WhatsAppLogo size={14} /><a href="https://wa.me/919731852956" className="hover:text-slate-900">WhatsApp</a></li>
            <li className="flex items-start gap-2.5"><Mail size={14} className="mt-1 text-[var(--steel)] shrink-0" /><a href="mailto:ramdevsteelfurniture369@gmail.com" className="hover:text-slate-900 break-all">ramdevsteelfurniture369@gmail.com</a></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="label-eyebrow mb-4">Explore</div>
          <ul className="space-y-2.5 text-slate-700 text-sm">
            <li><Link to="/products" className="hover:text-slate-900">Products</Link></li>
            <li><Link to="/gallery" className="hover:text-slate-900">Gallery</Link></li>
            <li><Link to="/about" className="hover:text-slate-900">About</Link></li>
            <li><Link to="/notice" className="hover:text-slate-900">Notice</Link></li>
            <li><Link to="/contact" className="hover:text-slate-900">Contact</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-slate-900">Privacy Policy</Link></li>
            <li><Link to="/terms-conditions" className="hover:text-slate-900">Terms & Conditions</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="label-eyebrow mb-4">{t.hours.title}</div>
          <ul className="space-y-1.5 text-slate-700 text-sm">
            <li className="text-slate-500 text-xs">{t.hours.mondaySaturday}</li>
            <li className="font-grotesk font-semibold">{t.hours.timeWeekday}</li>
            <li className="pt-2 text-slate-500 text-xs">{t.hours.sunday}</li>
            <li className="font-grotesk font-semibold">{t.hours.timeSunday}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Ramdev Steel Furniture & Fabrication. {t.footer.rights}</div>
          <div className="font-grotesk uppercase tracking-widest">Lingsugur · Karnataka · India</div>
        </div>
      </div>
    </footer>
  );
}
